(function () {
  if (window.__RS_GIFT_WRAP_INIT__) return;
  window.__RS_GIFT_WRAP_INIT__ = true;

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function formatMoneyPLN(cents) {
    const value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' zł';
    }
  }

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('data-open', 'true');
    document.documentElement.classList.add('rs-gift-modal-open');

    const closeBtn = qs('[data-rs-gift-close]', modal);
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal, returnFocusEl) {
    if (!modal) return;
    modal.hidden = true;
    modal.removeAttribute('data-open');
    document.documentElement.classList.remove('rs-gift-modal-open');

    if (returnFocusEl && typeof returnFocusEl.focus === 'function') {
      returnFocusEl.focus();
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart.js failed');
    return await res.json();
  }

  async function addVariantToCart(variantId) {
    const body = { items: [{ id: Number(variantId), quantity: 1 }] };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      let msg = 'Nie udało się dodać do koszyka.';
      try {
        const data = await res.json();
        if (data && data.description) msg = data.description;
      } catch (e) {}
      throw new Error(msg);
    }

    return await res.json();
  }

  async function fetchGiftProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Nie udało się pobrać produktu (products/*.js).');
    return await res.json();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const modal = qs('#rs-gift-wrap-modal');
    if (!modal) return;

    const openers = qsa('[data-rs-gift-open]');
    const addBtn = qs('[data-rs-gift-add]', modal);
    const statusEl = qs('[data-rs-gift-status]', modal);

    let lastFocus = null;
    let loadedOnce = false;

    function setStatus(text) {
      if (!statusEl) return;
      statusEl.hidden = !text;
      statusEl.textContent = text || '';
    }

    async function ensureGiftData() {
      if (!addBtn) return;
      if (loadedOnce && addBtn.getAttribute('data-variant-id')) return;

      const handle = addBtn.getAttribute('data-product-handle');
      const defaultText = addBtn.getAttribute('data-default-text') || 'Dodaj pakowanie do zamówienia';

      if (!handle) return;

      addBtn.disabled = true;
      addBtn.textContent = defaultText + '...';

      try {
        const product = await fetchGiftProduct(handle);
        const variant = (product.variants || []).find(v => v.available) || (product.variants || [])[0];
        if (!variant || !variant.id) throw new Error('Brak wariantu w product.js');

        const priceText = formatMoneyPLN(variant.price);

        addBtn.setAttribute('data-variant-id', String(variant.id));
        addBtn.textContent = `${defaultText} (${priceText})`;

        loadedOnce = true;
      } catch (err) {
        console.error(err);
        addBtn.textContent = 'Nie udało się pobrać ceny';
      } finally {
        addBtn.disabled = false;
      }
    }

    // OPEN
    openers.forEach((btn) => {
      btn.addEventListener('click', async () => {
        lastFocus = btn;
        setStatus('');
        openModal(modal);
        await ensureGiftData();
      });
    });

    // CLOSE: X + overlay
    modal.addEventListener('click', (e) => {
      const target = e.target;
      if (!target) return;

      // klik w overlay
      if (target.classList.contains('rs-gift-modal__overlay')) {
        closeModal(modal, lastFocus);
        return;
      }

      // klik w elementy z data-rs-gift-close
      if (target.matches('[data-rs-gift-close]')) {
        closeModal(modal, lastFocus);
      }
    });

    // ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModal(modal, lastFocus);
      }
    });

    // ADD
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const defaultText = addBtn.getAttribute('data-default-text') || 'Dodaj pakowanie do zamówienia';
        const addedText = addBtn.getAttribute('data-added-text') || 'Dodano ✓';

        if (!addBtn.getAttribute('data-variant-id')) {
          await ensureGiftData();
        }

        const variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) {
          setStatus('Nie udało się pobrać wariantu.');
          return;
        }

        const originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Dodaję...';
        setStatus('');

        try {
          const cart = await getCart();
          const already = cart.items && cart.items.some((it) => String(it.id) === String(variantId));

          if (already) {
            addBtn.textContent = addedText;
            setStatus('Pakowanie jest już w koszyku.');
            setTimeout(() => closeModal(modal, lastFocus), 650);
            return;
          }

          await addVariantToCart(variantId);

          addBtn.textContent = addedText;
          setStatus('Dodano do koszyka.');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            const notif = document.querySelector('cart-notification');
            if (notif && typeof notif.open === 'function') notif.open();
          }

          setTimeout(() => closeModal(modal, lastFocus), 650);
        } catch (err) {
          console.error(err);
          addBtn.disabled = false;
          addBtn.textContent = originalText || defaultText;
          setStatus(err.message || 'Coś poszło nie tak.');
          alert(err.message || 'Coś poszło nie tak.');
        }
      });
    }
  });
})();
